"use client";
import * as a from "react";
import m, { createContext as C, useId as D, useMemo as S, useContext as U, useState as A, useRef as x, useLayoutEffect as O, useEffect as h, useCallback as _ } from "react";
function G(t) {
  return (i) => ({
    styles: {
      ":root": {
        "--icon-offset": "1.9rem"
      },
      body: {
        paddingBottom: 2
      },
      label: {
        fontSize: 14,
        marginBottom: 4,
        display: "block",
        color: "#0a2540"
      },
      input: {
        height: 40,
        fontSize: 16,
        borderRadius: 6,
        color: "#0a2540",
        padding: "0 12px",
        backgroundColor: "#fff",
        border: "1px solid #e6ebf1",
        boxShadow: "0px 1px 1px rgba(0, 0, 0, .03), 0px 3px 6px rgba(0, 0, 0, .02)",
        "&::placeholder": {
          color: "#717f96"
        },
        "&:focus": {
          outline: "none",
          borderColor: "#63e"
        }
      },
      textarea: {
        height: 40,
        fontSize: 16,
        borderRadius: 6,
        color: "#0a2540",
        padding: "6px 12px",
        backgroundColor: "#fff",
        border: "1px solid #e6ebf1",
        boxShadow: "0px 1px 1px rgba(0, 0, 0, .03), 0px 3px 6px rgba(0, 0, 0, .02)",
        "&::placeholder": {
          color: "#717f96"
        },
        "&:focus": {
          outline: "none",
          borderColor: "#63e"
        }
      },
      select: {
        height: 40,
        fontSize: 16,
        borderRadius: 6,
        color: "#0a2540",
        padding: "6px 12px",
        backgroundColor: "#fff",
        border: "1px solid #e6ebf1"
      },
      button: {
        fontSize: 16,
        height: 40,
        border: "1px solid #e6ebf1",
        padding: "0 12px"
      },
      ".field[ev-valid=false] input": {
        color: "#df1c41",
        borderColor: "#df1c41"
      },
      ".error": {
        color: "#df1c41",
        fontSize: "0.75rem",
        padding: "0.25rem 0"
      },
      "[ev-component=card]": {
        gap: 16
      },
      "[ev-component=pin] input": {
        height: 80,
        fontSize: 20,
        caretColor: "transparent"
      },
      "[ev-component=card]:has(.icon)": {
        "& .field[ev-name=number]": {
          position: "relative"
        },
        "& .icon": {
          left: 10,
          height: 20,
          position: "absolute",
          top: "var(--icon-offset)"
        },
        "& .field[ev-name=number] input": {
          paddingLeft: 48
        }
      },
      ...t ? i.extend(t) : {}
    }
  });
}
function J(t) {
  return (i) => ({
    styles: {
      body: {
        paddingTop: 4
      },
      ".field": {
        position: "relative"
      },
      label: {
        top: 10,
        left: 8,
        zIndex: 3,
        fontSize: 14,
        lineHeight: 1,
        height: "20px",
        display: "flex",
        color: "#717f96",
        padding: "0 4px",
        alignItems: "center",
        position: "absolute",
        pointerEvents: "none",
        transformOrigin: "center left",
        transition: "transform 150ms, background 150ms"
      },
      input: {
        height: 40,
        fontSize: 16,
        borderRadius: 6,
        color: "#0a2540",
        padding: "0 12px",
        backgroundColor: "#fff",
        border: "1px solid #e6ebf1",
        "&::placeholder": {
          color: "transparent"
        },
        "&:focus": {
          outline: "none",
          borderColor: "#63e"
        }
      },
      textarea: {
        height: 40,
        fontSize: 16,
        borderRadius: 6,
        color: "#0a2540",
        padding: "6 12px",
        backgroundColor: "#fff",
        border: "1px solid #e6ebf1",
        "&::placeholder": {
          color: "transparent"
        },
        "&:focus": {
          outline: "none",
          borderColor: "#63e"
        }
      },
      ".field[ev-valid=false] input": {
        color: "#df1c41",
        borderColor: "#df1c41"
      },
      ".field:focus-within label, .field:not([ev-has-value=false]) label": {
        background: "white",
        transform: "translateY(-100%) scale(0.8)"
      },
      ".error": {
        color: "#df1c41",
        fontSize: "0.75rem",
        padding: "0.25rem 0"
      },
      ".field:not([ev-valid=false]):focus-within label": {
        color: "#63e"
      },
      ".field[ev-valid=false] label": {
        color: "#df1c41"
      },
      ".field[ev-has-value=true][ev-valid=true]:not(:focus-within) label": {
        color: "#0a2540"
      },
      "[ev-component=card]": {
        gap: 16
      },
      "[ev-component=card]:has(.icon)": {
        "& .icon": {
          left: 10,
          height: 20,
          position: "absolute",
          top: 10,
          opacity: 0
        },
        "& .field[ev-name=number]:focus-within, & .field[ev-name=number]:not([ev-has-value=false])": {
          "& .icon": {
            opacity: 1
          },
          "& input": {
            paddingLeft: 45
          }
        }
      },
      ...t ? i.extend(t) : {}
    }
  });
}
function N(t) {
  return (i) => ({
    styles: {
      ":root": {
        "--icon-offset": "34px"
      },
      body: {
        paddingBottom: 2
      },
      label: {
        fontSize: 14,
        marginBottom: "0.5rem",
        color: "#0a2540",
        display: "none"
      },
      ".field:first-child label": {
        display: "block"
      },
      "fieldset[ev-valid=false]": {
        paddingBottom: "1.5rem"
      },
      input: {
        height: 40,
        fontSize: 16,
        borderRadius: 0,
        color: "#0a2540",
        padding: "0 12px",
        backgroundColor: "#fff",
        border: "1px solid #e6ebf1",
        boxShadow: "0px 1px 1px rgba(0, 0, 0, .03), 0px 3px 6px rgba(0, 0, 0, .02)",
        "&::placeholder": {
          color: "#717f96"
        },
        "&:focus": {
          outline: "none",
          borderColor: "#63e"
        }
      },
      textarea: {
        height: 40,
        fontSize: 16,
        borderRadius: 0,
        color: "#0a2540",
        padding: "6 12px",
        backgroundColor: "#fff",
        border: "1px solid #e6ebf1",
        boxShadow: "0px 1px 1px rgba(0, 0, 0, .03), 0px 3px 6px rgba(0, 0, 0, .02)",
        "&::placeholder": {
          color: "#717f96"
        },
        "&:focus": {
          outline: "none",
          borderColor: "#63e"
        }
      },
      ".field[ev-valid=false] input": {
        color: "#df1c41",
        borderColor: "#df1c41"
      },
      ".error": {
        color: "#df1c41",
        fontSize: "0.75rem",
        padding: "0.25rem 0",
        position: "absolute",
        left: 0,
        bottom: 0,
        display: "none"
      },
      ".field[ev-valid=false]": {
        zIndex: 4
      },
      ".field:focus-within": {
        zIndex: 5
      },
      "[ev-component=card]": {
        gap: 0,
        "& .field[ev-valid=false]:nth-child(1) .error": {
          display: "block"
        },
        "& [ev-valid=true]:nth-child(1) + [ev-valid=false] .error": {
          display: "block"
        },
        "& [ev-valid=true]:nth-child(1) + [ev-valid=true]:nth-child(2) + [ev-valid=false] .error": {
          display: "block"
        },
        "& [ev-valid=true]:nth-child(1) + [ev-valid=true]:nth-child(2) + [ev-valid=true]:nth-child(3) + [ev-valid=false] .error": {
          display: "block"
        },
        "& .field:not(:last-child)": {
          marginBottom: "-1px"
        },
        "& .field:first-child": {
          "& input": {
            borderTopLeftRadius: 6,
            borderTopRightRadius: 6
          }
        },
        "& .field:last-child": {
          "& input": {
            borderBottomRightRadius: 6,
            borderBottomLeftRadius: 6
          }
        }
      },
      "[ev-component=card][ev-fields*=cvc][ev-fields*=expiry]": {
        "& .field[ev-name=expiry]": {
          "& input": {
            borderBottomLeftRadius: 6
          }
        },
        "& .field[ev-name=cvc]": {
          marginLeft: "-1px",
          "& input": {
            borderBottomLeftRadius: 0
          }
        }
      },
      "[ev-component=pin]": {
        gap: 0,
        "& input": {
          height: 60
        },
        "& .field:not(:first-child)": {
          marginLeft: "-1px"
        },
        "& .field:first-child input": {
          borderTopLeftRadius: 6,
          borderBottomLeftRadius: 6
        },
        "& .field:last-child input": {
          borderTopRightRadius: 6,
          borderBottomRightRadius: 6
        }
      },
      "[ev-component=card]:has(.icon)": {
        "& .icon": {
          left: 10,
          height: 20,
          position: "absolute",
          top: "var(--icon-offset)"
        },
        "& .field[ev-name=number] input": {
          paddingLeft: 48
        }
      },
      ...t ? i.extend(t) : {}
    }
  });
}
const re = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  clean: G,
  material: J,
  minimal: N
}, Symbol.toStringTag, { value: "Module" })), Y = C(null);
function E() {
  if (typeof window > "u")
    return null;
  if (typeof a.useContext != "function")
    throw new Error(
      "You must use React >= 18.0 in order to use useEvervault()"
    );
  const t = a.useContext(Y);
  if (!t)
    throw new Error(
      "You must wrap your app in an <EvervaultProvider> to use useEvervault()"
    );
  return t;
}
class Q extends Promise {
  async encrypt(i) {
    return (await this).encrypt(i);
  }
  async decrypt(i, e) {
    return (await this).decrypt(i, e);
  }
}
const W = "https://js.evervault.com/v2";
function X(t) {
  return new Promise((i, e) => {
    const o = document.createElement("script");
    o.addEventListener("load", () => {
      window.Evervault ? i(window.Evervault) : e(new Error("Evervault.js not available"));
    }), o.addEventListener("error", () => {
      e(new Error("Failed to load Evervault.js"));
    }), t && t !== "" ? o.src = t : o.src = W;
    const u = document.head || document.body;
    if (!u)
      throw new Error(
        "Expected document.body not to be null. Evervault.js requires a <body> element."
      );
    u.appendChild(o);
  });
}
const R = {};
function Z(t, i) {
  return R[t] || (R[t] = new Promise((e, o) => {
    if (typeof window > "u") {
      o(new Error("Evervault.js not available"));
      return;
    }
    if (window.Evervault) {
      console.warn("Evervault has already been loaded"), e(window.Evervault);
      return;
    }
    X(i == null ? void 0 : i.overrideUrl).then(e).catch(o);
  })), R[t];
}
function V(t, i) {
  const e = Z(t, i);
  let o = !1;
  return e.catch((u) => {
    o || console.warn(u);
  }), o = !0, e;
}
function F({
  teamId: t,
  appId: i,
  customConfig: e,
  onLoadError: o
}) {
  const u = D(), [f, r] = m.useState(0), [l, v] = m.useState(null);
  m.useEffect(() => {
    const s = `${u}-${f}-${e == null ? void 0 : e.jsSdkUrl}`;
    v(
      V(s, {
        overrideUrl: e == null ? void 0 : e.jsSdkUrl
      })
    );
  }, [u, f, e == null ? void 0 : e.jsSdkUrl, o]);
  const c = m.useMemo(() => new Q((s, p) => {
    l && l.then((b) => new b(t, i, e)).then(s, p);
  }), [l, t, i, e]), n = m.useCallback(() => {
    r((s) => s + 1);
  }, []);
  return S(() => ({ client: c, reload: n }), [c, n]);
}
const $ = C(
  void 0
);
function H() {
  const t = U($);
  if (!t)
    throw new Error("Reveal consumers must be used within a Reveal component");
  return t;
}
function K({
  path: t,
  onCopy: i,
  ...e
}) {
  const [o, u] = A(null), f = x(null), { reveal: r } = H();
  return a.useEffect(() => {
    if (r && i)
      return o == null ? void 0 : o.on("copy", i);
  }, [o, r, i]), O(() => {
    if (!f.current || o || !r) return;
    const l = r.copyButton(t, e);
    l.mount(f.current), u(l);
  }, [r, t, e, o]), /* @__PURE__ */ a.createElement("div", { ref: f });
}
function k({ path: t, theme: i, format: e }) {
  const [o, u] = A(null), f = x(null), { reveal: r } = H();
  return O(() => {
    if (!f.current || o || !r) return;
    const l = r.text(t, { theme: i, format: e });
    l.mount(f.current), u(l);
  }, [r, t, i, e, o]), /* @__PURE__ */ a.createElement("div", { ref: f });
}
function g({
  onMount: t,
  onUpdate: i,
  onMountError: e
}) {
  const o = E(), [u, f] = m.useState(null), r = m.useRef(e);
  return r.current = e, m.useLayoutEffect(() => {
    const l = new AbortController();
    async function v() {
      var c;
      try {
        const n = await o;
        if (!n || l.signal.aborted) return;
        const s = t(n);
        if (!s) return;
        f(s);
      } catch (n) {
        (c = r.current) == null || c.call(r, n), console.error(n);
      }
    }
    if (u)
      i == null || i(u);
    else
      return v(), () => l.abort();
  }, [o, t, i, u]), u;
}
function q({ request: t, children: i, onReady: e, onError: o }) {
  const u = g({
    onMount(r) {
      return r.ui.reveal(t);
    },
    onMountError: o
  }), f = a.useMemo(() => ({ reveal: u }), [u]);
  return a.useEffect(() => {
    if (!(!u || !e))
      return u == null ? void 0 : u.on("ready", e);
  }, [u, e]), a.useEffect(() => {
    if (!(!u || !o))
      return u == null ? void 0 : u.on("error", o);
  }, [u, o]), /* @__PURE__ */ a.createElement($.Provider, { value: f }, i);
}
q.Text = k;
q.CopyButton = K;
function te({
  theme: t,
  icons: i,
  fields: e,
  autoFocus: o,
  translations: u,
  onSwipe: f,
  onReady: r,
  onError: l,
  onChange: v,
  onComplete: c,
  onFocus: n,
  onBlur: s,
  onKeyUp: p,
  onKeyDown: b,
  autoComplete: L,
  autoProgress: z,
  acceptedBrands: P,
  defaultValues: B,
  redactCVC: M,
  allow3DigitAmexCVC: T
}) {
  const w = x(null), j = S(
    () => ({
      theme: t,
      icons: i,
      fields: e,
      autoFocus: o,
      translations: u,
      autoComplete: L,
      autoProgress: z,
      acceptedBrands: P,
      defaultValues: B,
      redactCVC: M,
      allow3DigitAmexCVC: T
    }),
    [
      t,
      i,
      u,
      e,
      o,
      L,
      z,
      P,
      B,
      M,
      T
    ]
  ), d = g({
    onMount(y) {
      if (!w.current) return;
      const I = y.ui.card(j);
      return I.mount(w.current), I;
    },
    onUpdate(y) {
      y.update(j);
    },
    onMountError: l
  });
  return h(() => {
    if (!(!d || !r))
      return d == null ? void 0 : d.on("ready", r);
  }, [d, r]), h(() => {
    if (!(!d || !l))
      return d == null ? void 0 : d.on("error", l);
  }, [d, l]), h(() => {
    if (!(!d || !f))
      return d == null ? void 0 : d.on("swipe", f);
  }, [d, f]), h(() => {
    if (!(!d || !v))
      return d == null ? void 0 : d.on("change", v);
  }, [d, v]), h(() => {
    if (!(!d || !c))
      return d == null ? void 0 : d.on("complete", c);
  }, [d, c]), h(() => {
    if (!(!d || !n))
      return d == null ? void 0 : d.on("focus", n);
  }, [d, n]), h(() => {
    if (!(!d || !s))
      return d == null ? void 0 : d.on("blur", s);
  }, [d, s]), h(() => {
    if (!(!d || !p))
      return d == null ? void 0 : d.on("keyup", p);
  }, [d, p]), h(() => {
    if (!(!d || !b))
      return d == null ? void 0 : d.on("keydown", b);
  }, [d, b]), /* @__PURE__ */ a.createElement("div", { ref: w });
}
function oe({
  theme: t,
  autoFocus: i,
  mode: e,
  inputType: o,
  length: u,
  onReady: f,
  onChange: r,
  onError: l
}) {
  const v = x(null), c = S(
    () => ({
      theme: t,
      length: u,
      autoFocus: i,
      mode: e,
      inputType: o
    }),
    [t, u, i, e, o]
  ), n = g({
    onMount(s) {
      if (!v.current) return;
      const p = s.ui.pin(c);
      return p.mount(v.current), p;
    },
    onUpdate(s) {
      s.update(c);
    },
    onMountError: l
  });
  return a.useEffect(() => {
    if (!(!n || !f))
      return n == null ? void 0 : n.on("ready", f);
  }, [n, f]), a.useEffect(() => {
    if (!(!n || !l))
      return n == null ? void 0 : n.on("error", l);
  }, [n, l]), a.useEffect(() => {
    if (!(!n || !r))
      return n == null ? void 0 : n.on("change", r);
  }, [n, r]), /* @__PURE__ */ a.createElement("div", { ref: v });
}
function ne({
  session: t,
  theme: i,
  size: e,
  onReady: o,
  onError: u,
  onSuccess: f,
  onFailure: r,
  failOnChallenge: l
}) {
  const v = a.useRef(null), c = a.useMemo(
    () => ({
      theme: i,
      size: e,
      failOnChallenge: l
    }),
    [i, e, l]
  ), n = g({
    onMount(s) {
      if (!v.current) return;
      const p = s.ui.threeDSecure(t, c);
      return p.mount(v.current), p;
    },
    onUpdate(s) {
      s.update(c);
    },
    onMountError: u
  });
  return a.useEffect(() => {
    if (!(!n || !o))
      return n == null ? void 0 : n.on("ready", o);
  }, [n, o]), a.useEffect(() => {
    if (!(!n || !f))
      return n == null ? void 0 : n.on("success", f);
  }, [n, f]), a.useEffect(() => {
    if (!(!n || !r))
      return n == null ? void 0 : n.on("failure", r);
  }, [n, r]), a.useEffect(() => {
    if (!(!n || !u))
      return n == null ? void 0 : n.on("error", u);
  }, [n, u]), /* @__PURE__ */ a.createElement("div", { ref: v });
}
function ie(t) {
  const i = E(), e = x(null), o = _(
    (f, r) => {
      e.current && (e.current.unmount(), e.current = null);
      async function l() {
        const v = await i;
        if (v)
          try {
            e.current = v.ui.threeDSecure(f, t), r != null && r.onReady && e.current.on("ready", r.onReady), r != null && r.onSuccess && e.current.on("success", r.onSuccess), r != null && r.onFailure && e.current.on("failure", r.onFailure), r != null && r.onError && e.current.on("error", r.onError), e.current.mount();
          } catch (c) {
            e.current = null, r != null && r.onError && r.onError(c);
          }
      }
      l();
    },
    [i, t]
  );
  h(() => () => {
    e.current && (e.current.unmount(), e.current = null);
  }, []);
  const u = _((f) => {
    e.current && e.current.update(f);
  }, []);
  return {
    start: o,
    update: u
  };
}
const ue = a.forwardRef(({ teamId: t, appId: i, customConfig: e, children: o, onLoadError: u, ...f }, r) => {
  const { client: l, reload: v } = F({
    teamId: t,
    appId: i,
    customConfig: e,
    onLoadError: u
  });
  return a.useImperativeHandle(r, () => ({
    reload: v
  })), /* @__PURE__ */ a.createElement(Y.Provider, { ...f, value: l }, o);
});
function de({
  onChange: t,
  config: i,
  onInputsLoad: e
}) {
  const o = a.useId();
  if (typeof window > "u")
    return /* @__PURE__ */ a.createElement("div", { id: o });
  const u = E(), { height: f = "auto", ...r } = i ?? {}, l = r ? { height: f, ...r } : { height: f };
  return a.useEffect(() => {
    u == null || u.then((v) => {
      const c = v.inputs(o, l);
      c == null || c.on("change", (n) => {
        typeof t == "function" && t(n);
      }), e && (c == null ? void 0 : c.isInputsLoaded) != null && c.isInputsLoaded instanceof Promise && c.isInputsLoaded.then(() => e());
    });
  }, [u]), /* @__PURE__ */ a.createElement("div", { id: o });
}
function fe({
  request: t,
  config: i,
  onCopy: e,
  onRevealLoad: o,
  onRevealError: u
}) {
  const f = a.useId();
  if (typeof window > "u")
    return /* @__PURE__ */ a.createElement("div", { id: f });
  const r = E(), { height: l = "auto", ...v } = i ?? {}, c = v ? { height: l, ...v } : { height: l };
  return a.useEffect(() => {
    r == null || r.then((n) => {
      const s = n.reveal(f, t, c, e);
      (s == null ? void 0 : s.isRevealLoaded) != null && s.isRevealLoaded instanceof Promise && s.isRevealLoaded.then(() => {
        o && o();
      }).catch((p) => {
        u && u(p);
      });
    });
  }, [r]), /* @__PURE__ */ a.createElement("div", { id: f });
}
export {
  te as Card,
  de as EvervaultInput,
  ue as EvervaultProvider,
  fe as EvervaultReveal,
  oe as Pin,
  q as Reveal,
  ne as ThreeDSecure,
  re as themes,
  E as useEvervault,
  ie as useThreeDSecure
};
